// 非VIP用户点歌第二首后的挽留弹窗
const notvipOrderedSecondSong = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20211228/vadd/3b9d0b088f2b68b25b71ffaa30e8f191.png',
    swiperData: [
        'https://qncweb-back1.ktvsky.com/20210721/vadd/95c3e80356ddd93d6d6515693fe40fb1.png',
        'https://qncweb-back1.ktvsky.com/20210705/vadd/2162d5dcf6842eeb00b42f545b5a8c78.png',
        'https://qncweb-back1.ktvsky.com/20210705/vadd/0d1d3b9ddd687eb31c76855079be70e4.png',
        // 'https://qncweb-back1.ktvsky.com/20210705/vadd/91d0e1dbb766926554de5c2e866038f0.png',
    ],
    statName: '点歌后演唱会召回弹窗',
    page_tp: 'dainge_old_concert',
    isShowAddOnePackages: true,
    propStyleVar: {
        fontColor: {
            normal: ['#4A4949', '#B64404', '#7B7676'],
            selected: ['#fff', '#EDD7B3', '#fff'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: 'linear-gradient(180deg,#14001a, #3f1047)',
        tipBg: '#F78117',
        plusColor: '#FF0000',
        tagBg: '#FF0000',
        swiperBulletBg: '#9FA0A0',
        swiperBulletActiveBg: '#FFFFFF',
        buttonHeight: '18vw',
        borderColor: {
            normal: '#FFFFFF',
            selected: '#FEAB35',
        },
    },
}
// 非VIP新用户第一个开屏弹窗
const firstHomeToast = {
    contentBg: 'https://qncweb.ktvsky.com/20230606/other/fbe3b1eb6de251f15d7a4e7cc940b9bb.png',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    page_tp: 'kaiping_moresong',
    className: 'kaiping_moresong',
    statName: '新开屏弹窗开通VIP',
    isShowGiveFriend: true,
    isBottomPosition: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#333333', '#6100FF', '#666666'],
            selected: ['#333333', '#6100FF', '#666666'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: '#FFFFFF',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#F2483D',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '15.5vw',
        borderColor: {
            normal: '#fff',
            selected: '#FF7D54',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}
// role2开屏弹窗2
const secondHomeToastRole2 = {
    contentBg: 'https://qncweb.ktvsky.com/20250718/vadd/e8cbea589bf1b9587c377e966136f458.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    isBottomType: true,
    className: 'bottom_big tip-border-radius',
    isBottomPosition: true,
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    selectIndex: 1,
    showUserAvatarText: '您还不是VIP',
    isMonthDiscount: true,
    isShowCountDownNoFinish: true,
    isDiscount: true,
    tagContentNew: ['', '立减5元', ''],
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb.ktvsky.com/20250718/vadd/957cf48a37660997e3e04f7a8082e962.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
        leftPosition: '10vw',
        leftSelected: '4vw',
    },
    giveFriendPackages: [{
        'pkg_id': 77,
        'current_fee': 1998,
        'desc': '1日体验+赠送好友',
        'days': 1,
    },
    {
        'pkg_id': 51,
        'desc': '29.8元/1个月',
        'origin_fee': 3998,
        'current_fee': 2980,
        'days': 30,
    },
    {
        'pkg_id': 49,
        'current_fee': 4380,
        'desc': '3个月+赠送好友',
        'days': 365,
    }],
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#666666', '#613218', '#666666'],
            selected: ['#666666', '#613218', '#666666'],
        },
        packageBg: '#ffffff',
        packageBgSelected: '#FBECD2',
        timeTipBg: '#FA3D54',
        tagBg: '#FF2828',
        tagTop: '-0.8vw',
        buttonHeight: '16vw',
        borderColor: {
          normal: '#E6E6E6',
          selected: '#FA3D54',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}

// 非VIP老用户第一个开屏弹窗增加常唱
const firstHomeToastOldHotsongs = {
    newCloseType: true,
    limitClose: true,
    contentBg: 'https://qncweb.ktvsky.com/20250331/vadd/8d60aa57e84a9cdfd7cab568c3279e12.png',
    newCloseImg: 'https://qncweb.ktvsky.com/20251216/vadd/c21181a998f3d0bcd8ad83cd9fb1e468.png',
    closeClassName: 'top-right-close-new',
    showAgreement: true,
    page_tp: 'oldvip_kaiping_cc',
    className: 'new_oldvip_kaiping',
    statName: '特权召回弹窗-有常唱',
    isShowGiveFriend: true,
    selectIndex: 1,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    propStyleVar: {
        maskColor: '#00000099',
        raisePadding: '0 0 2vw 0',
        raiseMaskBgColor: '#00000080',
        fontColor: {
            normal: ['#3B3533', '#3D3B40', '#00000066'],
            selected: ['#3B3533', '#3D3B40', '#00000066'],
        },
        packageBg: '#ffdfbf33',
        packageBgSelected: '#ffdfbfb3',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#F2483D',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '22vw',
        borderColor: {
            normal: '#FFDFBF',
            selected: '#0000007d',
        },
    },
}
// 非VIP老用户第一个开屏弹窗
const firstHomeToastOld = {
    contentBg: 'https://qncweb.ktvsky.com/20250605/vadd/ba5980338a81ee33b8c9cb6dcdeef5d7.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    closeClassName: 'top-right-close-new',
    isShowTextCountDown: true,
    limitClose: true,
    newCloseType: true,
    page_tp: 'new_oldvip_kaiping',
    className: 'new_oldvip_kaiping',
    statName: '特权召回弹窗',
    showAgreement: true,
    isShowGiveFriend: true,
    selectIndex: 1,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    propStyleVar: {
        maskColor: '#00000099',
        fontColor: {
            normal: ['#000000', '#3E372F', '#0000004D'],
            selected: ['#000000', '#3E372F', '#0000004D'],
        },
        packageBg: '#FFF8F0',
        packageBgSelected: 'linear-gradient(180deg, #ECAC43 13.88%, #ffffff 100%)',
        tipBg: '#B04CFB',
        tagTop: '-1vw',
        plusColor: '#B750FA',
        tagBg: '#F2483D',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '19vw',
        borderColor: {
            normal: '#FFDEAC',
            selected: '#5B3A14',
        },
        borderWidth: {
          normal: '0.6vw',
          selected: '0.6vw',
        },
    },
}
// 90后过期手机端弹窗 点歌接口返回 21002 && 非VIP
const guoqiDevice90 = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20230417/other/483d1426323332338ccad8ee8201ec0e.png',
    showAgreement: true,
    swiperData: [
        'https://qncweb-back1.ktvsky.com/20210719/vadd/8085021172a49224a91ff98dae0e060f.png',
        'https://qncweb-back1.ktvsky.com/20210719/vadd/179cc6b34f8326d7074967a5540221d8.png',
    ],
    page_tp: 'expire90', // 支付埋点参数
    statName: '90后到期设备弹窗', // 点击开通会员按钮埋点参数
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    propStyleVar: {
        fontColor: {
            normal: ['#4A4949', '#FA810D', '#7b7676'],
            selected: ['#fff', '#EDD7B3', '#fff'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: 'url(https://qncweb-back1.ktvsky.com/20210719/vadd/5872c9d61a5948b79abff4f867f43153.png) no-repeat',
        tipBg: '#3B2B0D',
        plusColor: '#8835FF',
        tagBg: '#FF0000',
        swiperBulletBg: '#8E7C5E',
        swiperBulletActiveBg: '#090602',
        buttonHeight: '15.5vw',
    },
}
// 已点页 非VIP第2、4、6次点击置顶操作
const topToast = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20230417/other/b9b2597e58b24ad8a33450e9f1f28265.png',
    showAgreement: true,
    page_tp: 'new_ordered_top', // 支付埋点参数
    statName: '新已点页置顶弹窗', // 点击开通会员按钮埋点参数
    propStyleVar: {
        fontColor: {
            normal: ['#666666', '#9F4613', '#9B9FA7'],
            selected: ['#2A1615', '#9F4613', '#9B9FA7'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: '#FFFFFF',
        tipBg: '#018864',
        plusColor: '#FF0000',
        tagBg: '#F2483D',
        swiperBulletBg: '#907f60',
        swiperBulletActiveBg: '#090602',
        buttonHeight: '18vw',
        borderColor: {
            normal: '#FFFCF2',
            selected: '#89470A',
        },
        logoBg: {
            normal: '#FFEECC',
            selected: '#FFEECC',
        },
    },
}
// 已点页-非VIP过期用户首次点击置顶操作
const oldUserFirstClickTop = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20230419/other/6230f9c279e98045ebab986548aa4377.png',
    showAgreement: true,
    page_tp: 'new_oldvip_ordered',
    statName: '已点页召回弹窗',
    hideIconApp: true,
    hidePlus: true,
    hideTip: true,
    className: 'new_oldvip_ordered',
    propStyleVar: {
        fontColor: {
            normal: ['#666666', '#9F4613', '#9B9FA7'],
            selected: ['#2A1615', '#9F4613', '#9B9FA7'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: '#FFFFFF',
        tipBg: '#3B2B0D',
        plusColor: '#B750FA',
        tagBg: '#F2483D',
        swiperBulletBg: '#47383838',
        swiperBulletActiveBg: '#383838',
        buttonHeight: '19vw',
        borderColor: {
            normal: '#FFFCF2',
            selected: '#89470A',
        },
    },
}
// vip歌曲弹窗通用配置
const vipSongToast = {
  showAgreement: true,
  limitClose: true,
  newCloseType: true,
  isBottomType: true,
  className: 'bottom_big',
  isBottomPosition: true,
  selectIndex: 1,
  isMonthDiscount: true,
  discountIndex: 1,
  discountDayFee: '0.02',
  isDiscount: true,
  memberIdArr: [78, 52, 50],
  price: [990, 1490, 2190],
  tagContentNew: ['', '立省5元', ''],
  propStyleVar: {
      raiseWight: '100vw',
      fontColor: {
          normal: ['#666666', '#613218', '#613218'],
          selected: ['#666666', '#613218', '#613218'],
      },
      packageBg: 'url(https://qncweb-back1.ktvsky.com/20240312/vadd/ed3054eb823b4b0603d72e3c2d2a3b4f.png)',
      packageBgSelected: 'url(https://qncweb-back1.ktvsky.com/20240312/vadd/d2d40232d3f8a437d48d1744e72bf5c7.png)',
      timeTipBg: '#CC9149',
      tagBg: '#FF2828',
      buttonHeight: '22.5vw',
  },
}
// DJ歌曲的弹窗
const djhotToast = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20240316/vadd/e1985a37067098e371cfafd781ae27b9.png',
    statName: '新DJ热曲会员收入',
    ...vipSongToast
}
// 舞曲的弹窗
const wuquToast = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20240328/vadd/c8e828a10c23c3e41a5969fb6963676e.png',
    statName: '舞曲串烧会员收入',
    ...vipSongToast
}
// 私人曲库非VIP弹窗
const personalSongToast = {
    swiperData: [
        'https://qncweb-back1.ktvsky.com/20220227/vadd/01e92b379f31246687d28e3cef6790bc.png',
        'https://qncweb-back1.ktvsky.com/20220227/vadd/c7882aa3db36b26b3f91c9b58ec5ee50.png',
        'https://qncweb-back1.ktvsky.com/20220227/vadd/892ae56a66f9ad3d261cfcd5d535a92e.png',
        // 'https://qncweb-back1.ktvsky.com/20220227/vadd/3d6f3087466737c32dae2ad9f8ed22f2.png',
    ],
    propStyleVar: {
        fontColor: {
            normal: ['#4A4949', '#FA810D', '#7B7676'],
            selected: ['#8702FF', '#8600FF', '#B351FF'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: 'url(https://qncweb-back1.ktvsky.com/20220227/vadd/7f1c73ca48c8f9dbb7d6ce225bb07ad0.png)',
        tipBg: '#FFE72B',
        tipColor: '#8600FF',
        plusColor: '#953DFE',
        tagBg: '#F2483D',
        swiperBulletBg: '#8E7D5E',
        swiperBulletActiveBg: '#090602',
        buttonHeight: '21vw',
    },
}
// 触摸屏已点广告-歌神 /thunder/openvip?FromType=touch_order_vip_cc
const touchOrderVipGstc = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20220401/vadd/fde4f98b082418965e2e19f7ff9e9234.png',
    swiperData: [
        'https://qncweb-back1.ktvsky.com/20210721/vadd/95c3e80356ddd93d6d6515693fe40fb1.png',
        'https://qncweb-back1.ktvsky.com/20210705/vadd/2162d5dcf6842eeb00b42f545b5a8c78.png',
        'https://qncweb-back1.ktvsky.com/20210705/vadd/0d1d3b9ddd687eb31c76855079be70e4.png',
        // 'https://qncweb-back1.ktvsky.com/20210705/vadd/91d0e1dbb766926554de5c2e866038f0.png',
    ],
    statName: '触摸已点歌神',
    page_tp: 'touch_order_vip_gstc',
    propStyleVar: {
        ...notvipOrderedSecondSong.propStyleVar,
        buttonHeight: '25vw',
    },
}

const vipHotsongsOld = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20231219/other/fb71d9f03e76365406a4df754a4da368.png',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    statName: '新用户vip伴奏弹窗点击开通会员',
    page_tp: 'vip_new_kaiping2',
    propStyleVar: {
        raiseMaskBgColor: '#00000080',
        fontColor: {
            normal: ['#3B3533', '#3D3B40', '#00000066'],
            selected: ['#3B3533', '#3D3B40', '#00000066'],
        },
        packageBg: '#ffdfbf33',
        packageBgSelected: '#ffdfbfb3',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#F2483D',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '21vw',
        borderColor: {
            normal: '#FFDFBF',
            selected: '#0000007d',
        },
    },
}

const homeToastBy82 = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20231213/other/50be0cdb71a304835fd53fb9fd1fac9b.png',
    className: 'light-bg',
    hideClose: true,
    limitClose: true,
    showAgreement1: true,
    page_tp: 'kaiping_vip_6.9',
    statName: '开屏弹窗1-VIP6.9',
    propStyleVar: {
        raiseMaskBgColor: '#00000080',
        fontColor: {
            normal: ['#7B4A00', '#883700', '#909090'],
            selected: ['#333333', '#883700', '#909090'],
        },
        tagBg: '#FF2805',
        packageBg: '#ffdfbf33',
        packageBgSelected: '#FCE7BA',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '23vw',
        tagRadius: '6px',
        borderColor: {
            normal: '#E0E0E0',
            selected: '#EBBD78',
        },
    },
    selectIndex: 1,
    isMonthDiscount: true,
    isDiscount: true,
    packagesContent: {
        showTag: true,
        tagContent: ['', '续费减5元', ''],
    },
    giveFriendPackages: [{
        'pkg_id': 77,
        'current_fee': 1980,
        'desc': '1日体验+赠送好友',
        'days': 1,
    },
    {
        'pkg_id': 51,
        'desc': '29.8元/1个月',
        'origin_fee': 3980,
        'current_fee': 2980,
        'days': 30,
    },
    {
        'pkg_id': 49,
        'current_fee': 4380,
        'desc': '3个月+赠送好友',
        'days': 365,
    }],
}
// 非VIP过期用户第二个开屏弹窗
const Role4VipKaiPing2 = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20240507/vadd/1af4f9f2c03f716323cca02bcbdc6612.png',
    selectIndex: 1,
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    page_tp: 'oldvip_diange2',
    className: 'kaiping_moresong',
    statName: '过期用户开屏弹窗2',
    isMonthDiscount: true,
    isDiscount: true,
    isBottomPosition: true,
    packagesContent: {
        showTag: true,
        tagContent: ['', '今日特惠 立减5元', ''],
        countdownTime: 3,
    },
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#333333', '#6100FF', '#666666'],
            selected: ['#333333', '#6100FF', '#666666'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: '#FFFFFF',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#F2483D',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '15.5vw',
        borderColor: {
            normal: '#fff',
            selected: '#FF7D54',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}
// 开屏弹窗2-新用户
const newUserPop2 = {
    hideClose: true,
    contentBg: 'https://qncweb-back1.ktvsky.com/20230720/other/b198f8c43ed9ead4afa9e9d8bac2e47f.png',
    limitClose: true,
    statName: '开屏弹窗新用户第二个1日体验',
    showAgreement1: true,
    propStyleVar: {
        raiseMaskBgColor: '#00000080',
        fontColor: {
            normal: ['#3B3533', '#3D3B40', '#00000066'],
            selected: ['#3B3533', '#3D3B40', '#00000066'],
        },
        packageBg: '#ffdfbf33',
        packageBgSelected: '#ffdfbfb3',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#F2483D',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '22vw',
        borderColor: {
            normal: '#FFDFBF',
            selected: '#0000007d',
        },
    },
}
// 开屏弹窗2-老用户
const oldUserPop2 = {
    contentBg: 'https://qncweb.ktvsky.com/20250630/vadd/fc363a1530a124f35493699c2d6e0088.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    closeClassName: 'top-right-close-new',
    limitClose: true,
    statName: '开屏弹窗2-role5',
    showUserAvatar: true,
    showCrown: true,
    isMonthDiscount: true,
    bottomAgreement: true,
    tagContentNew: ['', '续费减5元', ''],
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    propStyleVar: {
        maskColor: '#00000099',
        fontColor: {
            normal: ['#222124', '#883700', '#AC6200'],
            selected: ['#222124', '#883700', '#AC6200'],
        },
        tagBg: '#F2483D',
        packageBg: '#FFFFFF',
        packageBgSelected: 'url(https://qncweb-back1.ktvsky.com/20230920/vadd/1e605d05c852b5b170c0b1bd3700954f.png)',
        buttonHeight: '16vw',
        buttonMargin: '3vw 0',
    },
}
// 过期用户-第三个开屏弹窗
const thirdSplashPopup = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20240409/other/08bee6c1d5283a95e17408878f1874d9.png',
    statName: 'vip伴奏弹窗点击开通会员',
    page_tp: 'vip_old_kaiping2',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    selectIndex: 1,
    isMonthDiscount: true,
    isDiscount: true,
    tagContentNew: ['', '限时减5元', ''],
    propStyleVar: {
        raiseMaskBgColor: '#00000080',
        fontColor: {
            normal: ['#3B3533', '#3D3B40', '#00000066'],
            selected: ['#3B3533', '#3D3B40', '#00000066'],
        },
        packageBg: '#ffdfbf33',
        packageBgSelected: '#ffdfbfb3',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#F2483D',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '21vw',
        borderColor: {
            normal: '#FFDFBF',
            selected: '#0000007d',
        },
    },
}
// 非vip-点歌后-第1首
const noVipOrderSongFirst = {
    hideClose: true,
    limitClose: true,
    showAgreement1: true,
    propStyleVar: {
        raiseMaskBgColor: '#00000080',
        fontColor: {
            normal: ['#3B3533', '#3D3B40', '#00000066'],
            selected: ['#3B3533', '#3D3B40', '#00000066'],
        },
        packageBg: '#ffdfbf33',
        packageBgSelected: '#ffdfbfb3',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#F2483D',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '25vw',
        borderColor: {
            normal: '#FFDFBF',
            selected: '#0000007d',
        },
    },
}

// 非vip（新）-点歌后-第1首
const noVipNewOrderSongFirst = {
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    showAgreement: true,
    isBottomPosition: true,
    isMonthDiscount: true,
    isDiscount: true,
    selectIndex: 1,
    packagesContent: {
        tagContent: ['', '已减5元', ''],
        countdownText: '优惠剩余',
        countdownTime: 3,
    },
    propStyleVar: {
        raiseWight: '100vw',
        raiseMaskBgColor: '#00000080',
        fontColor: {
            normal: ['#333333', '#613218', '#666666'],
            selected: ['#333333', '#613218', '#666666'],
        },
        packageBg: '#ffdfbf33',
        packageBgSelected: '#ffdfbfb3',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#FFA240',
        tagTop: '-0.2vw',
        tagRadius: '6px 0 6px 0',
        tagColor: '#612D10',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '17vw',
        borderColor: {
            normal: '#FFDFBF',
            selected: '#0000007d',
        },
    },
}

// 过期用户-点歌后-第一首
const noVipNewOrderSongFirstRole4 = {
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    showAgreement: true,
    isBottomPosition: true,
    propStyleVar: {
        raiseWight: '100vw',
        raiseMaskBgColor: '#00000080',
        fontColor: {
            normal: ['#333333', '#613218', '#666666'],
            selected: ['#333333', '#613218', '#666666'],
        },
        packageBg: '#ffdfbf33',
        packageBgSelected: '#ffdfbfb3',
        buttonHeight: '17vw',
        borderColor: {
            normal: '#FFDFBF',
            selected: '#0000007d',
        },
      },
}

// 从未付费-点歌后弹窗
const noVipNewOrderSongFirstRole5 = {
    ...noVipNewOrderSongFirst,
    // isAnimationBtn: 'https://qncweb-back1.ktvsky.com/20240822/vadd/5fee469d657ee98a07ec1612908050cf.png', // 是否有动画按钮
    isShowBtnCountDown: true,
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    packagesContent: {
        showTag: false,
        bottomTip: '更多人选择'
    },
    propStyleVar: {
      fontColor: {
        normal: ['#000', '#FF6B00', 'rgba(0,0,0,0.3)'],
        selected: ['#000', '#FF6B00', 'rgba(0,0,0,0.3)'],
      },
      packageBg: '#fff',
      packageBgSelected: '#FFF2DF',
      tipBg: '#B04CFB',
      plusColor: '#B750FA',
      tagBg: '#FFA240',
      tagTop: '-0.8vw',
      tagRadius: '6px 0 6px 0',
      tagColor: '#612D10',
      buttonHeight: '12vw',
      borderColor: {
        normal: '#FFDEAC',
        selected: '#FF6B00',
      },
      borderWidth: {
        selected: '0.8vw',
      },
    },
}
// vip-点歌后弹窗
const vipNewOrderSong = {
    contentBg: 'https://qncweb.ktvsky.com/20250704/vadd/514be6b10c76a6878c7c339844156334.png',
    newCloseImg: 'https://qncweb.ktvsky.com/20250422/vadd/25adc9123e22d052f2c15bbfe0460227.png',
    closeClassName: 'top-right-close-new',
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    showAgreement: true,
    isBottomPosition: true,
    isMonthDiscount: true,
    isShowBtnCountDown: true,
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    packagesContent: {
        showTag: false,
        bottomTip: '更多人选择'
    },
    propStyleVar: {
      maskColor: '#00000080',
      fontColor: {
        normal: ['#000', '#FF6B00', 'rgba(0,0,0,0.3)'],
        selected: ['#000', '#FF6B00', 'rgba(0,0,0,0.3)'],
      },
      packageBg: '#fff',
      packageBgSelected: '#FFF2DF',
      tipBg: '#B04CFB',
      plusColor: '#B750FA',
      tagBg: '#FFA240',
      tagTop: '-0.8vw',
      tagRadius: '6px 0 6px 0',
      tagColor: '#612D10',
      buttonHeight: '12vw',
      borderColor: {
        normal: '#FFDEAC',
        selected: '#FF6B00',
      },
      borderWidth: {
        selected: '0.8vw',
      },
    },
}
// 新vip-点歌后弹窗
const vipNewOrderSongRole1 = {
    contentBg: 'https://qncweb.ktvsky.com/20250825/vadd/7cec9d1e6ea63f75e6d4b1606234418d.png',
    newCloseImg: 'https://qncweb.ktvsky.com/20250422/vadd/25adc9123e22d052f2c15bbfe0460227.png',
    closeClassName: 'top-right-close-new',
    className: 'bottom_big',
    showUserAvatarText: '已为您加入已点',
    avatarTextClass: 'avatar-text-new',
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    showAgreement: true,
    showAgreementText: true,
    isBottomPosition: true,
    isMonthDiscount: true,
    noShowCountDown: true,
    isShowGiveFriend: true,
    tagContentNew: ['', '立省5元', ''],
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb.ktvsky.com/20250825/vadd/be846ad5a18604a734f7d81a7862328a.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
        leftPosition: '10vw',
        leftSelected: '4vw',
    },
    propStyleVar: {
      maskColor: '#00000080',
      fontColor: {
        normal: ['#000', '#FF6B00', 'rgba(0,0,0,0.3)'],
        selected: ['#000', '#FF6B00', 'rgba(0,0,0,0.3)'],
      },
      packageBg: '#fff',
      packageBgSelected: '#DFFFDF',
      tipBg: '#B04CFB',
      plusColor: '#B750FA',
      tagBg: '#F31D20',
      tagColor: '#fff',
      tagTop: '-2.667vw',
      tagRadius: '6px 0 6px 0',
      buttonHeight: '16vw',
      borderColor: {
        normal: '#F1F1F1',
        selected: '#00DEAE',
      },
      borderWidth: {
        selected: '0.8vw',
      },
    },
}
// role3-点歌后-第一首
const vipNewOrderSongRole3 = {
    contentBg: 'https://qncweb.ktvsky.com/20250801/vadd/e269500346a7c441afc4226a4ce55b8b.png',
    newCloseImg: 'https://qncweb.ktvsky.com/20250422/vadd/25adc9123e22d052f2c15bbfe0460227.png',
    closeClassName: 'top-right-close-new',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    isBottomPosition: true,
    statName: '搜索初始页双十一弹窗',
    isMonthDiscount: true,
    isDiscount: true,
    packagesContent: {
        showTag: true,
        tagContent: ['', '立减5元', ''],
        countdownSuffixText: '后结束',
    },
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    propStyleVar: {
        maskColor: '#00000080',
        fontColor: {
            normal: ['#4C4C4A', '#4C4C4A', 'rgba(0,0,0,0.3)'],
            selected: ['#000000', '#FF6B00', 'rgba(0,0,0,0.3)'],
        },
        tagBg: '#F2483D',
        packageBg: '#EDECE8',
        packageBgSelected: '#FFF2DF',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagTop: '-0.8vw',
        tagRadius: '6px 0 6px 0',
        tagColor: '#ffffff',
        buttonHeight: '12vw',
        borderColor: {
            normal: '#D9D9D9',
            selected: '#FF6B00',
        },
        borderWidth: {
            normal: '0.5vw',
            selected: '0.8vw',
        },
    },
}

// VIP体验会员挽留弹窗
const vipExperienceToast = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20220818/other/ffc2adc9fc4855636347adfa2e17f6a6.png',
    statName: '开屏弹窗:1分钟免费会员',
    page_tp: 'kaiping_new_mianfei',
    isShowFootbar: true,
    propStyleVar: {
        // raiseWight: '89vw',
        raisePadding: '0 0 1vw 0',
        fontColor: {
            normal: ['#FFFFFF', '#FFFFFF', 'rgba(255, 255, 255, 0.5)'],
            selected: ['#EB1B10', '#EB1B10', '#EB1B10'],
        },
        packageBg: '#DD1B25',
        packageBgSelected: 'linear-gradient(-180deg,#FFEFAB,#FFC320)',
        tipBg: '#A50718',
        tipColor: '#FFFFFF',
        plusUrl: 'https://qncweb-back1.ktvsky.com/20220818/other/2e7c02c5347bd92b02b5a24f680c512e.png',
        tagBg: '#ff8a4f',
        buttonHeight: '22vw',
        handUrl: 'https://qncweb-back1.ktvsky.com/20220818/other/9f00502bfc1234a0b29d6f097f691652.png',
        // borderColor: {
        //     normal: '#fff',
        //     selected: '#f90eb6',
        // },
    },
}
// 搜索结果页非vip置顶按钮
const noVipSearchResultTopPop = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20230417/other/b85baa9f7d18bbececa875ff24d2e047.png',
    showAgreement: true,
    statName: '优先唱按钮开通会员收益',
    propStyleVar: {
        fontColor: {
            normal: ['#666666', '#9F4613', '#9B9FA7'],
            selected: ['#2A1615', '#9F4613', '#9B9FA7'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: '#FFFFFF',
        tagBg: '#F2483D',
        buttonHeight: '18vw',
        borderColor: {
            normal: '#FFFCF2',
            selected: '#7F280D',
        },
    },
}
// 搜索结果页非vip置顶按钮
const noVipSearchResultTopPopRole5 = {
    contentBg: 'https://qncweb.ktvsky.com/20250827/vadd/9381e7ebbc76c34a29343facb23a4473.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    limitClose: true,
    closeClassName: 'top-left-close',
    bottomAgreement: true,
    showCrown: true,
    showUserAvatar: true,
    isMonthDiscount: true,
    isDiscount: true,
    selectIndex: 1,
    discountIndex: 1,
    discountDayFee: '0.02',
    memberIdArr: [78, 52, 50],
    price: [990, 1490, 2190],
    showAgreement: true,
    statName: '优先唱按钮开通会员收益',
    packagesContent: {
        showTag: true,
        tagContent: ['', '立减5元', ''],
        countdownSuffixText: '后结束',
    },
    propStyleVar: {
        showExpireImg: true,
        fontColor: {
            normal: ['#000000', '#3E372F', '#0000004D'],
            selected: ['#37262C', '#3E372F', '#0000004D'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: '#D4D4FC',
        tagBg: '#F2483D',
        buttonHeight: '22vw',
        borderColor: {
            normal: '#FFFFFF',
            selected: '#D4D4FC',
        },
    },
}
// 歌手详情页非vip优先唱按钮
const noVipSingerTopPopRole5 = {
    limitClose: true,
    newCloseType: true,
    showAgreement: true,
    selectIndex: 1,
    contentBg: 'https://qncweb-back1.ktvsky.com/20231204/vadd/fee4e3485ecb056e1a3798c43fad348d.png',
    statName: '优先唱按钮开通会员收益',
    page_tp: 'ordertoast_ssjg2',
    propStyleVar: {
        fontColor: {
            normal: ['#666666', '#9F4613', '#9B9FA7'],
            selected: ['#2A1615', '#9F4613', '#9B9FA7'],
        },
        packageBg: '#FFFCF2',
        packageBgSelected: '#FFFCF2',
        buttonHeight: '19vw',
        borderColor: {
            normal: '#FFFCF2',
            selected: '#7F280D',
        },
    },
}
// 搜索结果页非vip优先唱按钮role4
const noVipSearchResultTopPopRole4 = {
    contentBg: 'https://qncweb.ktvsky.com/20250911/vadd/880839c0f5d76b97a6591c81d08973de.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    limitClose: true,
    bottomAgreement: true,
    selectIndex: 1,
    showUserAvatar: true,
    userAvatarClass: 'avatar_frame',
    statName: '搜索结果优先唱',
    className: 'bottom_big search_tc_role2',
    page_tp: 'ordertoast_ssjg2',
    packagesContent: {
        showTag: true,
        tagContent: ['', '最多人选择', ''],
    },
    propStyleVar: {
        raiseWight: '90.6vw',
        fontColor: {
            normal: ['#000000', '#FF134A', '#00000099'],
            selected: ['#000000', '#FF134A', '#00000099'],
        },
        packageBg: 'url(https://qncweb.ktvsky.com/20250910/vadd/4f058267a22c12721ad75b29f84b7fc1.png)',
        packageBgSelected: 'url(https://qncweb.ktvsky.com/20250910/vadd/c7de88e848b1dc2365573306c565c9e9.png)',
        tagBg: '#FF115E',
        timeTipBg: '#FF115E',
        bottomTipRadius: '0 0 3vw 3vw',
        buttonHeight: '24vw',
        avatarFrameWidth: '18.4vw',
        avatarFrameHeight: '18.4vw',
        avatarFrameUrl: 'https://qncweb.ktvsky.com/20250911/vadd/cc870132a8bf3bd0b637be23f690961d.png',
        userImgWidth: '15vw',
        userImgHeight: '15vw',
    },
}

// 搜索初始页弹窗
const searchInitToast = {
  contentBg: 'https://qncweb-back1.ktvsky.com/20240227/vadd/416b657ce14f1d1ed1569afcb488adcc.png',
  showAgreement: true,
  limitClose: true,
  newCloseType: true,
  isBottomType: true,
  isBottomPosition: true,
  statName: '搜索初始页双十一弹窗',
  page_tp: 'search_tc_one',
  className: 'search_tc_role4 bottom_big',
  showAgreement1: true,
  selectIndex: 1,
  isMonthDiscount: true,
  discountIndex: 1,
  discountDayFee: '0.02',
  isDiscount: true,
  memberIdArr: [78, 52, 50],
  price: [990, 1490, 2190],
  tagContentNew: ['', '立省5元', ''],
  propStyleVar: {
    raiseWight: '100vw',
    fontColor: {
      normal: ['#7B4A00', '#222124', '#00000066'],
      selected: ['#7B4A00', '#222124', '#00000066'],
    },
    packageBg: '#fff',
    packageBgSelected: '#ffdfbfb3',
    tipBg: '#B04CFB',
    timeTipBg: '#FF5051',
    plusColor: '#B750FA',
    tagBg: '#FF2828',
    tagTop: '-2.667vw',
    swiperBulletBg: 'rgba(255,255,255,0.25)',
    swiperBulletActiveBg: '#fff',
    buttonHeight: '26vw',
    buttonMargin: '5vw 0',
    borderColor: {
      normal: '#0000000d',
      selected: '#0000007d',
    },
  },
}

// 搜索初始页弹窗-皇冠
const searchInitRole = {
    contentBg: 'https://qncweb.ktvsky.com/20250811/vadd/0961e11e6b51248451bbb31dd61edfe6.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    showAgreement: true,
    bottomAgreement: true,
    limitClose: true,
    newCloseType: true,
    statName: '搜索初始页双十一弹窗',
    page_tp: 'search_tc_yzs',
    className: 'bottom_big search_tc_role2',
    isDiscount: true,
    selectIndex: 1,
    isMonthDiscount: true,
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb.ktvsky.com/20250811/vadd/07ecf2958ccda3bd95192d2af2f1d20e.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
        leftPosition: '10vw',
        leftSelected: '4vw',
        pointMargin: '4vw auto 2vw',
    },
    tagContentNew: ['', '立减5元', ''],
    packagesContent: {
        countdownSuffixText: '后结束',
    },
    propStyleVar: {
        raiseWight: '93vw',
        maskColor: '#00000099',
        fontColor: {
            normal: ['#7B4A00', '#3D3C40', '#00000066'],
            selected: ['#7B4A00', '#3D3C40', '#00000066'],
        },
        packageBg: '#fff',
        packageBgSelected: 'linear-gradient(180deg,#F7EAC9, #F9C695)',
        tipBg: '#B04CFB',
        timeTipBg: '#FF2828',
        plusColor: '#B750FA',
        tagBg: '#FF2828',
        tagTop: '-2.667vw',
        buttonHeight: '19vw',
        buttonMargin: '1vw 0',
        borderColor: {
            normal: '#0000000d',
            selected: '#FF5A70',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}
// 抢先唱弹窗(非vip-从未付费)
const searchFirstToast = {
  contentBg: 'https://qncweb-back1.ktvsky.com/20231213/vadd/2bb6929803f70682d49dcb0d241c5597.jpeg',
  showAgreement: true,
  propStyleVar: {
    raiseMaskBgColor: '#00000080',
    fontColor: {
      normal: ['#3B3533', '#3D3B40', '#00000066'],
      selected: ['#3B3533', '#3D3B40', '#00000066'],
    },
    packageBg: '#ffdfbf33',
    packageBgSelected: '#ffdfbfb3',
    tipBg: '#B04CFB',
    plusColor: '#B750FA',
    tagBg: '#F2483D',
    swiperBulletBg: 'rgba(255,255,255,0.25)',
    swiperBulletActiveBg: '#fff',
    buttonHeight: '22vw',
    borderColor: {
      normal: '#FFDFBF',
      selected: '#0000007d',
    },
  },
}
// 搜索抢先唱弹窗(role2,role5)
const searchFirstToastNew = {
    contentBg: 'https://qncweb.ktvsky.com/20250328/vadd/19b2e44a7b35f8aab549d54aedb14812.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    isShowTextCountDown: true,
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    isBottomPosition: true,
    statName: '搜索结果抢鲜唱弹窗',
    className: 'bottom_big',
    propStyleVar: {
        fontColor: {
            normal: ['#7B4A00', '#222124', '#00000066'],
            selected: ['#7B4A00', '#222124', '#00000066'],
        },
        packageBg: '#fff',
        packageBgSelected: '#FFFFFFB2',
        tipBg: '#F31D20',
        timeTipBg: '#CC9149',
        timeTipColor: '#613218',
        plusColor: '#B750FA',
        tagBg: '#FF4343',
        tagColor: '#fff',
        tagTop: '-0.3vw',
        tagPadding: '0 6.5vw',
        tagRadiusNew: '1.33vw 1.33vw 0 0',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '14vw',
        borderColor: {
            normal: '#0000000D',
            selected: '#FF5A70',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
  }
const equityVip = {
    statName: '优先唱按钮开通会员收益',
    pkgsDes: ['适合单次消费，精选伴奏随心唱，礼物无限发！', '有点小划算，适合短期K歌用户', '超划算，更省钱，适合长期K歌用户'],
    propStyleVar: {
        fontColor: {
            normal: ['#666666', '#993E2E', '#9A9FA8'],
            selected: ['#20183B', '#20183B', '#9A9FA8'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: '#FFFFFF',
        buttonHeight: '39vw',
        borderColor: {
            normal: '#FFFFFF',
            selected: '#20183B',
        },
    },
}
// 我的已点页banner弹窗
const orderedBanner = {
    contentBg: 'https://qncweb.ktvsky.com/20250319/vadd/5f372f4556c68d9a2fe2150abd847aa6.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    isShowTextCountDown: true,
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    isBottomPosition: true,
    statName: '已点页弹窗',
    className: 'bottom_big month_first',
    isMonthDiscount: true,
    isDiscount: true,
    tagContentNew: ['立省5元', '', ''],
    isMonthFirstDiscount: true,
    propStyleVar: {
        fontColor: {
            normal: ['#7B4A00', '#222124', '#00000066'],
            selected: ['#7B4A00', '#222124', '#00000066'],
        },
        packageBg: '#fff',
        packageBgSelected: '#FFFFFFB2',
        tipBg: '#F31D20',
        timeTipBg: '#CC9149',
        timeTipColor: '#613218',
        plusColor: '#B750FA',
        tagBg: '#FF4343',
        tagColor: '#fff',
        tagTop: '-2.667vw',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '18vw',
        borderColor: {
            normal: '#0000000D',
            selected: '#FF5A70',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}
// 已点页头像支付弹窗
const orderedHead = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20230208/vadd/6dc9d259fcfbadfe9a4bf9a5c39f0863.png',
    statName: '已点页_会员头像',
    propStyleVar: {
        fontColor: {
            normal: ['#666666', '#9F4613', '#9C9FA6'],
            selected: ['#2A1615', '#9F4613', '#9B9FA7'],
        },
        packageBg: '#FFFCF2',
        packageBgSelected: '#FFFCF2',
        buttonHeight: '26vw',
        borderColor: {
            normal: '#FFFCF2',
            selected: '#7F280D',
        },
    },
}
const orderedHeadRole4 = {
    contentBg: 'https://qncweb.ktvsky.com/20250909/vadd/e9a35398c3d01a49243f0d117eb2d5cf.png',
    showUserAvatarText: 'USERNAME',
    avatarTextClass: 'avatar-and-name',
    statName: '已点页_会员头像',
    className: 'bottom_big search_tc_role2',
    isMonthDiscount: true,
    isDiscount: true,
    propStyleVar: {
        raiseWight: '90.6vw',
        fontColor: {
            normal: ['#000000', '#FF134A', '#00000099'],
            selected: ['#000000', '#FF134A', '#00000099'],
        },
        packageBg: 'url(https://qncweb.ktvsky.com/20250910/vadd/4f058267a22c12721ad75b29f84b7fc1.png)',
        packageBgSelected: 'url(https://qncweb.ktvsky.com/20250910/vadd/c7de88e848b1dc2365573306c565c9e9.png)',
        tagBg: '#FF115E',
        timeTipBg: '#FF115E',
        bottomTipRadius: '0 0 3vw 3vw',
        buttonHeight: '27vw',
    },
}
// 首页头像支付弹窗
const homeAvatarScene = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20230420/other/69ed84cc63546c3c54fc2b41e946a908.png',
    showAgreement: true,
    statName: '首页头像支付弹窗',
    className: 'home-avatar',
    propStyleVar: {
        fontColor: {
            normal: ['#666666', '#9F4613', '#9C9FA6'],
            selected: ['#2A1615', '#9F4613', '#9B9FA7'],
        },
        packageBg: '#FFFCF2',
        packageBgSelected: '#FFFCF2',
        buttonHeight: '20vw',
        borderColor: {
            normal: '#FFFCF2',
            selected: '#7F280D',
        },
    },
}
// 搜索结果歌神歌曲非vip弹窗
const geshenNoVip = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20221116/vadd/f01612bf7b0b4f97d61e1b6a081596c9.png',
    statName: '搜索页歌神版弹窗11-10',
    page_tp: 'sousuo_geshen',
    propStyleVar: {
        fontColor: {
          normal: ['#4A4949', '#B64404', '#A4A4A4'],
          selected: ['#fff', '#EDD7B3', '#fff'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: 'linear-gradient(180deg,#000000, #543c13)',
        buttonHeight: '26.2vw',
        borderColor: {
            normal: '#FFEECC',
            selected: '#FFBC54',
        },
    },
}
const HQsongNoVip = {
    contentBg: 'https://qncweb.ktvsky.com/20250623/vadd/189160184f55ae287f562465973b1bd4.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    closeClassName: 'top-right-close-new',
    limitClose: true,
    statName: 'HQ弹窗',
    showUserAvatar: true,
    showCrown: true,
    isMonthDiscount: true,
    bottomAgreement: true,
    tagContentNew: ['', '续费减5元', ''],
    propStyleVar: {
        maskColor: '#00000099',
        fontColor: {
            normal: ['#222124', '#883700', '#AC6200'],
            selected: ['#222124', '#883700', '#AC6200'],
        },
        tagBg: '#F2483D',
        packageBg: '#FFFFFF',
        packageBgSelected: 'url(https://qncweb-back1.ktvsky.com/20230920/vadd/1e605d05c852b5b170c0b1bd3700954f.png)',
        buttonHeight: '15.5vw',
        buttonMargin: '5vw 0',
    },
}
const HQsongNoVipRole5 = {
    contentBg: 'https://qncweb.ktvsky.com/20251113/vadd/d8ec73100ebfd948e1789ae2de154034.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    closeClassName: 'top-right-close-new',
    className: 'bottom_big cold-theme search_tc_role2',
    limitClose: true,
    statName: 'HQ弹窗',
    showUserAvatar: true,
    showCrown: true,
    isMonthDiscount: true,
    bottomAgreement: true,
    tagContentNew: ['', '续费减5元', ''],
    propStyleVar: {
        raiseWight: '94.67vw',
        maskColor: '#00000099',
        fontColor: {
            normal: ['#000000', '#999999', '#00000099'],
            selected: ['#000000', '#999999', '#00000099'],
        },
        avatarFrameWidth: '17.067vw',
        avatarFrameHeight: '17.067vw',
        crownUrl: 'https://qncweb.ktvsky.com/20251106/vadd/957f47f7d40a3f8187c06b566d0e404b.png',
        showExpireImg: true,
        tagBg: '#FF0053',
        packageBg: '#FFFFFF',
        packageBgSelected: '#ffffff',
        monthColorSpan: '#FF134A',
        buttonHeight: '20vw',
        buttonMargin: '5vw 0 8vw',
        borderColor: {
            normal: '#0000000D',
            selected: '#FF0053',
        },
        borderWidth: {
            normal: '0.6vw',
            selected: '0.8vw',
        },
    },
}
const HQsongSearchResult = {
    contentBg: 'https://qncweb.ktvsky.com/20250820/vadd/0b5649431b07bef841ad60d4a153b9d4.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    closeClassName: 'top-right-close-new',
    page_tp: 'sousuo_geshen_yzs',
    showAgreement: true,
    bottomAgreement: true,
    className: 'bottom_big search_tc_role2',
    limitClose: true,
    statName: 'HQ弹窗',
    showUserAvatar: true,
    isMonthDiscount: true,
    tagContentNew: ['', '立减5元', ''],
    packagesContent: {
        countdownSuffixText: '后结束',
    },
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb.ktvsky.com/20250820/vadd/cfe81c0900b4d136997125badc7e8a2b.png',
        point: 'https://qncweb.ktvsky.com/20250820/vadd/34b514c03da72f42979e0cc8d1bcec9a.png',
        pointWidth: '15.733vw',
        pointHeight: '6vw',
        topPosition: '0.933vw',
        leftPosition: '10vw',
        leftSelected: '4vw',
        pointMargin: '4vw auto 2vw',
    },
    propStyleVar: {
        raiseWight: '93vw',
        maskColor: '#00000099',
        fontColor: {
            normal: ['#7B4A00', '#3D3C40', '#00000066'],
            selected: ['#7B4A00', '#3D3C40', '#00000066'],
        },
        packageBg: '#fff',
        packageBgSelected: 'linear-gradient(180deg,#F7EAC9, #F9C695)',
        tipBg: '#B04CFB',
        timeTipBg: '#FF2828',
        plusColor: '#B750FA',
        tagBg: '#FF2828',
        tagTop: '-2.667vw',
        buttonHeight: '19vw',
        buttonMargin: '1vw 0',
        borderColor: {
            normal: '#0000000d',
            selected: '#FF5A70',
        },
        borderWidth: {
            selected: '0.8vw',
        },
        // 头像配置
        avatarFrameUrl: 'https://qncweb.ktvsky.com/20250820/vadd/67acfd1e6152bebfbe23d6d6e83dd289.png',
        avatarFrameWidth: '17.067vw', // 128px转换
        avatarFrameHeight: '17.067vw',
        userImgWidth: '15.2vw', // 114px转换
        userImgHeight: '15.2vw',
        showExpireImg: true, // 显示过期头像框
    },
}
const HQsongSearchResultRole5 = {
    contentBg: 'https://qncweb.ktvsky.com/20250714/vadd/66c8b1a111ce99f87cdb0c7b083b0bb5.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    closeClassName: 'top-right-close-new',
    page_tp: 'sousuo_geshen_yzs',
    showAgreementText: true,
    isBottomPosition: true,
    className: 'bottom_big tip-border-radius',
    limitClose: true,
    statName: 'HQ弹窗',
    showUserAvatar: true,
    showCrown: true,
    tagContentNew: ['', '续费减5元', ''],
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
        leftPosition: '10vw',
        leftSelected: '2vw',
    },
    propStyleVar: {
        raiseWight: '100vw',
        maskColor: '#00000099',
        fontColor: {
            normal: ['#000000', '#999999', '#00000066'],
            selected: ['#000000', '#999999', '#00000066'],
        },
        monthColorSpan: '#FF3D00',
        tagBg: '#F2483D',
        packageBg: '#FFFFFF',
        packageBgSelected: '#FFFFFF',
        timeTipBg: '#FFEBE5',
        timeTipColor: '#FF0000',
        buttonHeight: '15.5vw',
        buttonMargin: '5vw 0',
        borderColor: {
            normal: '#F4F0EB',
            selected: '#CE701A',
        },
        borderWidth: {
            selected: '0.8vw',
        },
        // 头像配置
        crownUrl: 'https://qncweb.ktvsky.com/20250714/vadd/5d87e24c97d3afe8eb1a094c7ad87e09.png',
        crownWidth: '8.667vw', // 65px转换
        crownHeight: '8.667vw',
        crownClass: 'crown-icon-custom', // 自定义皇冠样式类名
        avatarFrameUrl: 'https://qncweb.ktvsky.com/20250714/vadd/f13508fab9b1dcb885a6aa53774d8d0a.png',
        avatarFrameWidth: '17.067vw', // 128px转换
        avatarFrameHeight: '17.067vw',
        userImgWidth: '15.2vw', // 114px转换
        userImgHeight: '15.2vw',
        showExpireImg: true, // 显示过期头像框
    },
}
// 国庆中秋
const HQsongNoVipGuoQing = {
    contentBg: 'https://qncweb.ktvsky.com/20250924/vadd/6d5e55c852cb50542603be6861d66fd1.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    closeClassName: 'top-right-close-new',
    showAgreementText: true,
    limitClose: true,
    isBottomType: true,
    page_tp: 'HQ_Box',
    className: 'bottom_big',
    isBottomPosition: true,
    tagContentNew: ['', '续费减5元', ''],
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
        leftPosition: '10vw',
    },
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#666666', '#613218', '#613218'],
            selected: ['#666666', '#613218', '#613218'],
        },
        packageBg: 'url(https://qncweb.ktvsky.com/20250923/vadd/a017763f6be2d6459cc45d0822634ba1.png)',
        packageBgSelected: 'url(https://qncweb.ktvsky.com/20250923/vadd/04c773d50b6c89dd850370a0f678409f.png)',
        timeTipBg: '#FF5051',
        tagBg: '#FF2828',
        buttonHeight: '20vw',
        handTop: '54vw',
        handUrl: 'https://qncweb.ktvsky.com/20250923/vadd/4a59e3650f8a048b2329641f074d9b01.png',
    },
}
const HQsongNoVipNew = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20240312/vadd/dcecb805a703abea74c73731de19cced.png',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    className: 'bottom_big',
    isBottomPosition: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#666666', '#613218', '#613218'],
            selected: ['#666666', '#613218', '#613218'],
        },
        packageBg: 'url(https://qncweb-back1.ktvsky.com/20240312/vadd/ed3054eb823b4b0603d72e3c2d2a3b4f.png)',
        packageBgSelected: 'url(https://qncweb-back1.ktvsky.com/20240312/vadd/d2d40232d3f8a437d48d1744e72bf5c7.png)',
        timeTipBg: '#FF5051',
        tagBg: '#FF2828',
        buttonHeight: '22.5vw',
    },
}
const HQsongNoVipNewTopSong = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20240926/vadd/3518ef2ea194c7115eb56993620a943d.png',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    className: 'bottom_big month_first',
    isBottomPosition: true,
    showTopText: '您还不是VIP',
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#666666', '#613218', '#666666'],
            selected: ['#666666', '#613218', '#666666'],
        },
        packageBg: 'url(https://qncweb-back1.ktvsky.com/20240312/vadd/ed3054eb823b4b0603d72e3c2d2a3b4f.png)',
        packageBgSelected: '#ffffff',
        timeTipBg: '#FF7D54',
        tagBg: '#FF2828',
        tagTop: '-0.8vw',
        buttonHeight: '22.5vw',
        borderColor: {
            normal: '#FDE2E4',
            selected: '#FF7D54',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}
const HQsongNoVipNewSong = {
    contentBg: 'https://qncweb.ktvsky.com/20250402/vadd/2717695d6f7ff305d269f0f08bb7a166.png',
    newCloseImg: 'https://qncweb.ktvsky.com/20250422/vadd/25adc9123e22d052f2c15bbfe0460227.png',
    isShowTextCountDown: true,
    isShowTextCountDownBig: true,
    closeClassName: 'top-left-close',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    showTopText: '您还不是VIP',
    className: 'bottom_big month_first',
    isBottomPosition: true,
    isShowGiveFriend: 'true',
    isMonthDiscount: true,
    isMonthFirstDiscount: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20241213/vadd/b73f889254be3417aac707fb190cd873.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
        leftPosition: '10vw',
        leftSelected: '4vw',
        pointMargin: '3vw auto 1.067vw',
    },
    propStyleVar: {
        maskColor: '#00000099',
        raiseWight: '100vw',
        fontColor: {
            normal: ['#666666', '#613218', '#666666'],
            selected: ['#666666', '#613218', '#666666'],
        },
        packageBg: 'url(https://qncweb-back1.ktvsky.com/20240312/vadd/ed3054eb823b4b0603d72e3c2d2a3b4f.png)',
        packageBgSelected: '#ffffff',
        timeTipBg: '#FF7D54',
        tagBg: '#FF2828',
        tagTop: '-0.8vw',
        buttonHeight: '18vw',
        borderColor: {
            normal: '#FDE2E4',
            selected: '#FF7D54',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}
const SearchResultHQsongNoVipNew = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20241016/vadd/4f60ebc340b48b4c01b503a74e2ad6aa.png',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    isBottomType: true,
    className: 'bottom_big month_width',
    isBottomPosition: true,
    isMonthDiscount: true,
    isDiscount: true,
    selectIndex: 1,
    packagesContent: {
        showTag: true,
        tagContent: ['', '大促减5元', ''],
        countdownText: '优惠剩余',
    },
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    giveFriendPackages: [{
        'pkg_id': 77,
        'current_fee': 1980,
        'desc': '1日体验+赠送好友',
        'days': 1,
    },
    {
        'pkg_id': 51,
        'desc': '29.8元/1个月',
        'origin_fee': 3980,
        'current_fee': 2980,
        'days': 30,
    },
    {
        'pkg_id': 49,
        'current_fee': 4380,
        'desc': '3个月+赠送好友',
        'days': 365,
    }],
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#000000', '#FF6B00', 'rgba(0, 0, 0, 0.3)'],
            selected: ['#000000', '#FF6B00', 'rgba(0, 0, 0, 0.3)'],
        },
        packageBg: '#fff',
        packageBgSelected: '#FFF2DF',
        timeTipBg: '#FB1717',
        tagBg: '#FF2828',
        buttonHeight: '14vw',
        borderColor: {
            normal: '#FFDEAC',
            selected: '#FF6B00',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}
// VIP用户第二个开屏弹窗
const vipSecondHomeToast = {
    contentBg: 'https://qncweb.ktvsky.com/20250730/vadd/ef11889590effc4e005246f176d46430.png',
    newCloseImg: 'https://qncweb.ktvsky.com/20250422/vadd/25adc9123e22d052f2c15bbfe0460227.png',
    closeClassName: 'top-right-close-new',
    className: 'light-bg',
    showAgreement: true,
    topAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    page_tp: 'kaiping_vip_two',
    isNeedRole: true,
    statName: '开屏弹窗2-VIP',
    isBottomPosition: true,
    isMonthDiscount: true,
    discountIndex: 1,
    discountDayFee: '0.02',
    isDiscount: true,
    memberIdArr: [78, 52, 50],
    price: [990, 1490, 2190],
    selectIndex: 1,
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
    },
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#333333', '#6100FF', '#666666'],
            selected: ['#333333', '#6100FF', '#666666'],
        },
        packageBg: '#FFFFFF',
        packageBgSelected: '#FFFFFF',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#F2483D',
        swiperBulletBg: 'rgba(255,255,255,0.25)',
        swiperBulletActiveBg: '#fff',
        buttonHeight: '26.5vw',
        borderColor: {
            normal: '#fff',
            selected: '#FF7D54',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}

const CloudSong = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20241111/vadd/1ebc9dc7437d9966856caabca8e78ae2.png',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    className: 'bottom_big cloud-song',
    isBottomPosition: true,
    page_tp: 'cloud_song_speed',
    selectIndex: 1,
    isMonthDiscount: true,
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#666666', '#613218', '#613218'],
            selected: ['#666666', '#613218', '#613218'],
        },
        packageBg: 'url(https://qncweb-back1.ktvsky.com/20240312/vadd/ed3054eb823b4b0603d72e3c2d2a3b4f.png)',
        packageBgSelected: 'url(https://qncweb-back1.ktvsky.com/20240312/vadd/d2d40232d3f8a437d48d1744e72bf5c7.png)',
        timeTipBg: '#FF5051',
        tagBg: '#FF2828',
        buttonHeight: '23.5vw',
    },
}

// 抢鲜唱弹窗
const vipFirstRole4 = {
    contentBg: 'https://qncweb.ktvsky.com/20250624/vadd/af2e02f0765132aa6d4a8c70e9e07af8.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    isBottomPosition: true,
    isShowBtnCountDown: true,
    countdownBtnText: '立即抢鲜唱',
    statName: '首页歌单底部横条弹窗',
    page_tp: 'home_page_vip',
    className: 'search_tc_role4 bottom_big',
    showTopAgreement: true,
    selectIndex: 1,
    packagesContent: {
        showTag: false,
        bottomTip: '更多人选择'
    },
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#7B4A00', '#222124', '#00000066'],
            selected: ['#7B4A00', '#222124', '#00000066'],
        },
        packageBg: '#fff',
        packageBgSelected: '#ffffffb3',
        timeTipBg: '#FF5051',
        tagBg: '#FF2828',
        tagTop: '-2.667vw',
        buttonHeight: '18vw',
        countdownMargin: '6vw auto 3.1vw',
        countdownBg: 'rgb(252,56,88)',
        bottomTipRadius: '0 0 1.8vw 1.8vw',
        borderColor: {
            normal: '#0000000d',
            selected: '#FF5A70',
        },
    },
}

// 抢鲜唱弹窗
const vipFirstTopRole2 = {
    contentBg: 'https://qncweb.ktvsky.com/20250212/vadd/0271900f8f299fdcbd1b93c64ecaeade.png',
    isShowBtnCountDown: true,
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    limitClose: true,
    isBottomType: true,
    showAgreement: true,
    isBottomPosition: true,
    isMonthDiscount: true,
    isDiscount: true,
    selectIndex: 1,
    packagesContent: {
        showTag: false,
        bottomTip: '更多人选择'
    },
    propStyleVar: {
        fontColor: {
            normal: ['#000', '#FF6B00', 'rgba(0,0,0,0.3)'],
            selected: ['#000', '#FF6B00', 'rgba(0,0,0,0.3)'],
        },
        packageBg: '#fff',
        packageBgSelected: '#FFF2DF',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#FFA240',
        tagTop: '-0.8vw',
        tagRadius: '6px 0 6px 0',
        tagColor: '#612D10',
        buttonHeight: '12vw',
        borderColor: {
            normal: '#FFDEAC',
            selected: '#FF6B00',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}

// 抢鲜唱弹窗
const vipFirstSearchRole5 = {
    contentBg: 'https://qncweb.ktvsky.com/20250918/vadd/dbd1acee20ab483d49371372a0ceeb1e.png',
    className: 'search_tc_role4 bottom_big',
    isShowBtnCountDown: true,
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    limitClose: true,
    isBottomType: true,
    showAgreement: true,
    showAgreementText: true,
    isBottomPosition: true,
    selectIndex: 1,
    countdownBtnText: '立即抢鲜唱',
    tagContentNew: ['', '更多人选择', ''],
    packagesContent: {
        showTag: true,
        tagContent: ['', '更多人选择', ''],
    },
    propStyleVar: {
        fontColor: {
            normal: ['#000', '#999999', 'rgba(0,0,0,0.6)'],
            selected: ['#000', '#999999', 'rgba(0,0,0,0.6)'],
        },
        packageBg: '#fff',
        packageBgSelected: 'linear-gradient(180deg, #FFE186 3.33%, #FFFFFF 66.74%)',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        monthColorSpan: '#FF134A',
        tagBg: '#FF115E',
        tagTop: '-2vw',
        tagRadius: '6px 0 6px 0',
        tagColor: '#ffffff',
        buttonHeight: '17vw',
        countdownHeight: '17vw',
        countdownMargin: '6vw auto 3.1vw',
        countdownBg: 'linear-gradient(180deg, #FF0053 0%, #FF3C7B 100%)',
        borderColor: {
            normal: '#F4F0EB',
            selected: '#FF0B5A',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}

const homeBottomVipRole4 = {
    contentBg: 'https://qncweb.ktvsky.com/20260113/vadd/c1fd43d606a340573f96a30b5e20af4b.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    isBottomPosition: true,
    statName: '首页歌单底部横条弹窗',
    page_tp: 'home_page_vip',
    className: 'search_tc_role4 bottom_big',
    showAgreement1: true,
    selectIndex: 1,
    isMonthDiscount: true,
    discountIndex: 1,
    discountDayFee: '0.02',
    isSpecialPackages: 1,
    price: [999, 1690, 2190],
    // 兼容其它场景弹窗
    memberIdArr1: [78, 70, 50],
    isDiscount1: true, // 立减3元
    packagesContent: {
        showTag: true,
        month: ['24小时', '1个月', '3个月'],
        current: ['¥<span>0.41</span>/小时', '¥<span>0.02</span>/小时', '¥<span>0.01</span>/小时'],
        showFirstOrigin: true,
        origin: ['¥9.9', '¥16.9<i>¥19.9</i>', '¥21.9<i>¥29.9</i>'],
        tagContent: ['畅唱一天', '限时折扣', ''],
    },
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#333333', '#FF2C48', '#00000066'],
            selected: ['#333333', '#FF2C48', '#00000066'],
        },
        packageBg: '#F1EFFF',
        packageBgSelected: '#F1EFFF',
        timeTipBg: '#FF5051',
        tagBg: '#FF7083',
        tagTop: '-2.667vw',
        tagBold: 'normal',
        tagSize: '2.4vw',
        tagBgSelected: '#FF2B47',
        buttonHeight: '26vw',
        buttonMargin: '5vw 0',
        borderColor: {
            normal: '#E8DDF0',
            selected: '#A277FF',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}
// 歌单详情页-从未付费用户
const singerSongRole5 = {
    contentBg: 'https://qncweb-back1.ktvsky.com/20241111/vadd/8398b73f6e52872bc45ce31cff4e61c7.png',
    className: 'singer-vip-song',
    isShowBtnCountDown: true,
    isShowCountDownNoFinish: true,
    newCloseType: true,
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    limitClose: true,
    isBottomType: true,
    showAgreement: true,
    isBottomPosition: true,
    isMonthDiscount: true,
    isDiscount: true,
    selectIndex: 1,
    packagesContent: {
      showTag: false,
      bottomTip: '更多人选择',
    },
    propStyleVar: {
        fontColor: {
            normal: ['#000', '#FF6B00', 'rgba(0,0,0,0.3)'],
            selected: ['#000', '#FF6B00', 'rgba(0,0,0,0.3)'],
        },
        packageBg: '#fff',
        packageBgSelected: '#FFF2DF',
        tipBg: '#B04CFB',
        plusColor: '#B750FA',
        tagBg: '#FFA240',
        tagTop: '-0.8vw',
        tagRadius: '6px 0 6px 0',
        tagColor: '#612D10',
        buttonHeight: '12vw',
        countDownBg: '#FF6B00',
        borderColor: {
            normal: '#FFDEAC',
            selected: '#FF6B00',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}

const searchNewYearToast = {
    contentBg: 'https://qncweb.ktvsky.com/20250120/vadd/fe5179645b1ef0887adc74da932f3466.png',
    showAgreement: true,
    limitClose: true,
    newCloseType: true,
    isBottomType: true,
    className: 'bottom_big',
    isBottomPosition: true,
    isMonthDiscount: true,
    discountIndex: 1,
    discountDayFee: '0.02',
    isDiscount: true,
    tagContentNew: ['', '立省5元', ''],
    selectIndex: 1,
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#AC622B',
        bg: 'https://qncweb.ktvsky.com/20250120/vadd/f19656a49a81be37016bfafb2a2179f3.png',
        point: 'https://qncweb.ktvsky.com/20250120/vadd/47d1c93f0c147016c54fd96de9735e35.png',
        leftPosition: '10vw',
        leftSelected: '4vw',
    },
    propStyleVar: {
        raiseWight: '100vw',
        fontColor: {
            normal: ['#6C5246', '#6C5246', '#A57E68'],
            selected: ['#6C5246', '#6C5246', '#A57E68'],
        },
        packageBg: 'url(https://qncweb.ktvsky.com/20250120/vadd/d7a8bf4a482349a5fad8aef348443fa3.png)',
        packageBgSelected: 'url(https://qncweb.ktvsky.com/20250120/vadd/f0d88dd927471929dd572c506ce255d8.png)',
        timeTipBg: 'linear-gradient(90deg, #E87C4F 0%, #EE3E30 100%)',
        tagBg: 'linear-gradient(90deg, #E87C4F 0%, #EE3E30 100%)',
        buttonHeight: '18vw',
    },
}

const homeOfterSongRole2 = {
    contentBg: 'https://qncweb.ktvsky.com/20250821/vadd/b1f87e5f60c3acac25c7f183c6289e78.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    closeClassName: 'top-right-close-new',
    page_tp: 'homeoften_VIPsong_yzs',
    showAgreement: true,
    bottomAgreement: true,
    className: 'bottom_big search_tc_role2',
    limitClose: true,
    statName: 'HQ弹窗',
    isMonthDiscount: true,
    tagContentNew: ['', '立减5元', ''],
    packagesContent: {
        countdownSuffixText: '后结束',
    },
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb.ktvsky.com/20250811/vadd/07ecf2958ccda3bd95192d2af2f1d20e.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
        leftPosition: '10vw',
        leftSelected: '4vw',
        pointMargin: '4vw auto 2vw',
    },
    propStyleVar: {
        raiseWight: '93vw',
        maskColor: '#00000099',
        fontColor: {
            normal: ['#7B4A00', '#3D3C40', '#00000066'],
            selected: ['#7B4A00', '#3D3C40', '#00000066'],
        },
        packageBg: '#fff',
        packageBgSelected: 'linear-gradient(180deg,#F7EAC9, #F9C695)',
        tipBg: '#B04CFB',
        timeTipBg: '#FF2828',
        plusColor: '#B750FA',
        tagBg: '#FF2828',
        tagTop: '-2.667vw',
        buttonHeight: '19vw',
        buttonMargin: '1vw 0',
        borderColor: {
            normal: '#0000000d',
            selected: '#FF5A70',
        },
        borderWidth: {
            selected: '0.8vw',
        },
    },
}

const homeOfterSongRole5 = {
    contentBg: 'https://qncweb.ktvsky.com/20251120/vadd/1f771be34ee570e98d5e8869b6fcacc8.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    closeClassName: 'top-right-close-new',
    className: 'bottom_big',
    isBottomType: true,
    isBottomPosition: true,
    showAgreement: true,
    showAgreementText: true,
    limitClose: true,
    newCloseType: true,
    selectIndex: 1,
    isMonthDiscount: true,
    isShowCountDownNoFinish: true,
    isDiscount: true,
    tagContentNew: ['', '立减5元', ''],
    statName: '首页常唱推荐歌曲弹窗',
    page_tp: 'homeoften_VIPsong_yzs',
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb.ktvsky.com/20250811/vadd/07ecf2958ccda3bd95192d2af2f1d20e.png',
        point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
        leftPosition: '10vw',
        leftSelected: '4vw',
        pointMargin: '4vw auto 2vw',
    },
    propStyleVar: {
        maskColor: '#00000099',
        fontColor: {
            normal: ['#000000', '#999999', '#00000066'],
            selected: ['#000000', '#999999', '#00000066'],
        },
        packageBg: 'url(https://qncweb.ktvsky.com/20251113/vadd/a017763f6be2d6459cc45d0822634ba1.png)',
        packageBgSelected: 'url(https://qncweb.ktvsky.com/20251113/vadd/c00ddc280429f591ab268049b7621a81.png)',
        monthColorSpan: '#FF134A',
        tipBg: '#B04CFB',
        timeTipBg: '#FF2828',
        plusColor: '#B750FA',
        tagBg: '#FF2828',
        tagTop: '-2.667vw',
        buttonHeight: '15vw',
        buttonMargin: '1vw 0',
        borderColor: {
            normal: '#F4F0EB',
            selected: '#FA3D54',
        },
        borderWidth: {
            normal: '0.6vw',
            selected: '0vw',
        },
        handTop: '66vw',
        handUrl: 'https://qncweb.ktvsky.com/20250923/vadd/4a59e3650f8a048b2329641f074d9b01.png',
    },
}

// role4万圣节弹窗配置
const halloweenToastRole4 = {
    contentBg: 'https://qncweb.ktvsky.com/20251113/vadd/ebb24f5baa727210d870d390d70ca7af.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    isBottomType: true,
    className: 'bottom_big',
    isBottomPosition: true,
    showAgreement: true,
    showAgreementText: true,
    limitClose: true,
    newCloseType: true,
    selectIndex: 1,
    isMonthDiscount: true,
    isShowCountDownNoFinish: true,
    isDiscount: true,
    tagContentNew: ['', '立减5元', ''],
    statName: '万圣节弹窗',
    page_tp: 'classified_song',
    propStyleVar: {
        fontColor: {
            normal: ['#000000', '#999999', '#00000066'],
            selected: ['#000000', '#999999', '#00000066'],
        },
        packageBg: 'url(https://qncweb.ktvsky.com/20251113/vadd/a017763f6be2d6459cc45d0822634ba1.png)',
        packageBgSelected: 'url(https://qncweb.ktvsky.com/20251113/vadd/c00ddc280429f591ab268049b7621a81.png)',
        monthColorSpan: '#FF134A',
        tipBg: '#B04CFB',
        timeTipBg: '#FF2828',
        plusColor: '#B750FA',
        tagBg: '#FF2828',
        tagTop: '-2.667vw',
        buttonHeight: '22vw',
        buttonMargin: '1vw 0',
        borderColor: {
            normal: '#F4F0EB',
            selected: '#FA3D54',
        },
        borderWidth: {
            normal: '0.6vw',
            selected: '0vw',
        },
        handTop: '60vw',
        handUrl: 'https://qncweb.ktvsky.com/20250923/vadd/4a59e3650f8a048b2329641f074d9b01.png',
    },
}

// 元旦头像弹窗
const newYearAvatarToast = {
    contentBg: 'https://qncweb.ktvsky.com/20251230/vadd/0ad96a88951744ac2f72452f236b339a.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    closeClassName: 'top-right-close-new',
    page_tp: 'sousuo_geshen_yzs',
    showAgreement: true,
    bottomAgreement: true,
    className: 'bottom_big search_tc_role2',
    limitClose: true,
    statName: '头像弹窗',
    showUserAvatar: true,
    isMonthDiscount: true,
    tagContentNew: ['', '立减5元', ''],
    packagesContent: {
        countdownSuffixText: '后结束',
    },
    propStyleVar: {
        raiseWight: '93vw',
        maskColor: '#00000099',
        fontColor: {
            normal: ['#7B4A00', '#3D3C40', '#00000066'],
            selected: ['#7B4A00', '#3D3C40', '#00000066'],
        },
        packageBg: '#fff',
        packageBgSelected: 'linear-gradient(180deg,#F7EAC9, #F9C695)',
        tipBg: '#B04CFB',
        timeTipBg: '#FF2828',
        plusColor: '#B750FA',
        tagBg: '#FF2828',
        tagTop: '-2.667vw',
        buttonHeight: '21vw',
        buttonMargin: '1vw 0',
        borderColor: {
            normal: '#0000000d',
            selected: '#FF5A70',
        },
        borderWidth: {
            selected: '0.8vw',
        },
        // 头像配置
        avatarFrameUrl: 'https://qncweb.ktvsky.com/20250820/vadd/67acfd1e6152bebfbe23d6d6e83dd289.png',
        avatarFrameWidth: '17.067vw', // 128px转换
        avatarFrameHeight: '17.067vw',
        userImgWidth: '15.2vw', // 114px转换
        userImgHeight: '15.2vw',
        showExpireImg: true, // 显示过期头像框
    },
}

const SearchResultHQsongRole4 = {
    contentBg: 'https://qncweb.ktvsky.com/20251110/vadd/66d7eb3fddf113dbb801a9f285a9ea90.png',
    newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
    newCloseType: true,
    closeClassName: 'top-right-close-new',
    showAgreementText: true,
    limitClose: true,
    isBottomType: true,
    page_tp: 'HQ_Box',
    className: 'bottom_big search_tc_role2',
    tagContentNew: ['', '续费减5元', ''],
    isShowGiveFriend: true,
    giveFriendConfig: {
        color: '#fc433f',
        bg: 'https://qncweb.ktvsky.com/20250820/vadd/cfe81c0900b4d136997125badc7e8a2b.png',
        point: 'https://qncweb.ktvsky.com/20250820/vadd/34b514c03da72f42979e0cc8d1bcec9a.png',
        pointWidth: '15.733vw',
        pointHeight: '6vw',
        topPosition: '0.933vw',
        leftPosition: '10vw',
        leftSelected: '4vw',
        pointMargin: '4vw auto 2vw',
    },
    propStyleVar: {
        raiseWight: '93vw',
        fontColor: {
            normal: ['#666666', '#613218', '#613218'],
            selected: ['#666666', '#613218', '#613218'],
        },
        packageBg: 'url(https://qncweb.ktvsky.com/20250923/vadd/a017763f6be2d6459cc45d0822634ba1.png)',
        packageBgSelected: 'url(https://qncweb.ktvsky.com/20250923/vadd/04c773d50b6c89dd850370a0f678409f.png)',
        timeTipBg: '#FF5051',
        tagBg: '#FF2828',
        bottomTipRadius: '0 0 1.33vw 1.33vw',
        buttonHeight: '16vw',
    },
}

const homeOfterSong = {
    contentBg: 'https://qncweb.ktvsky.com/20251114/vadd/d970dffe99f682d47d975275e4970b72.png',
    showAgreement: true,
    limitClose: true,
    className: 'bottom_big search_tc_role2',
    statName: '常唱引导会员弹窗',
    newCloseImg: 'https://qncweb.ktvsky.com/20250402/vadd/b41aa6618d66870e7abeb9e5dba6a9c3.png',
    closeClassName: 'top-right-close-top',
    newCloseType: true,
    selectIndex: 1,
    isDiscount: true,
    isMonthDiscount: true,
    tagContentNew: ['', '立减5元', ''],
    propStyleVar: {
        raiseWight: '92vw',
        fontColor: {
            normal: ['#000000', '#3D3C40', '#999999'],
            selected: ['#000000', '#3D3C40', '#999999'],
        },
        packageBg: '#fff',
        packageBgSelected: '#fff',
        monthColorSpan: '#FF134A',
        tipBg: '#FB1717',
        plusColor: '#8835FF',
        tagBg: 'linear-gradient(180deg, #FF0053 0%, #FF3C7B 100%)',
        tagLeft: '5.5vw',
        tagTop: '-3vw',
        tagRadiusNew: '20px',
        tagPadding: '0.5vw 2.2vw',
        buttonHeight: '23vw',
        borderColor: {
            normal: '#0000001A',
            selected: '#FF0053',
        },
        borderWidth: {
            normal: '0.6vw',
            selected: '0.8vw',
        },
    },
};

export {
    newUserPop2,
    oldUserPop2,
    geshenNoVip,
    noVipSearchResultTopPop,
    noVipSearchResultTopPopRole5,
    noVipSearchResultTopPopRole4,
    searchInitToast,
    searchInitRole,
    searchFirstToast,
    searchFirstToastNew,
    noVipOrderSongFirst,
    noVipNewOrderSongFirst,
    noVipNewOrderSongFirstRole4,
    noVipNewOrderSongFirstRole5,
    vipNewOrderSong,
    vipNewOrderSongRole1,
    vipNewOrderSongRole3,
    Role4VipKaiPing2,
    notvipOrderedSecondSong,
    firstHomeToast,
    secondHomeToastRole2,
    guoqiDevice90,
    topToast,
    oldUserFirstClickTop,
    djhotToast,
    wuquToast,
    personalSongToast,
    touchOrderVipGstc,
    vipHotsongsOld,
    firstHomeToastOld,
    homeToastBy82,
    firstHomeToastOldHotsongs,
    vipExperienceToast,
    equityVip,
    orderedBanner,
    orderedHead,
    orderedHeadRole4,
    homeAvatarScene,
    thirdSplashPopup,
    HQsongNoVip,
    HQsongNoVipRole5,
    HQsongSearchResult,
    HQsongSearchResultRole5,
    HQsongNoVipGuoQing,
    HQsongNoVipNew,
    HQsongNoVipNewTopSong,
    HQsongNoVipNewSong,
    SearchResultHQsongNoVipNew,
    vipSecondHomeToast,
    noVipSingerTopPopRole5,
    CloudSong,
    vipFirstRole4,
    vipFirstTopRole2,
    vipFirstSearchRole5,
    homeBottomVipRole4,
    singerSongRole5,
    searchNewYearToast, // 搜索新年推荐弹窗
    homeOfterSongRole2,
    homeOfterSongRole5,
    homeOfterSong,
    halloweenToastRole4, // role4万圣节弹窗配置
    newYearAvatarToast, // 立冬主题弹窗
    SearchResultHQsongRole4,
}
